/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';

// @ts-ignore
import WakeboardFlexNumber from "./wakeboard-flex-number";

// @ts-ignore
import {GetLocalText} from "./../../themes/kent/utilities/functions";
// @ts-ignore
import {GeneralAssetUrl} from "./../../themes/kent/utilities/constants";

interface IState {
  specs?: any;
}

interface IProps {
  product?: any;
  year?:any;
  forceBrandColor?:any;
}

/**
 *
 * WakeboardSpecs component
 * @extends {React.PureComponentReact.Component<IProps,IState>}
 */

class WakeboardSpecs extends React.Component<IProps,IState> {
  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state = {};
  }

  public componentDidMount = async () => {
    this.setUpScreen();
  }

  public setUpScreen = () =>{
		var skill = this.props.product.attributes.wakeboardSkill;
		var pop = this.props.product.attributes.wakeboardPopRocker;
		var flex = this.props.product.attributes.wakeboardFlex;
		var terrain = this.props.product.attributes.wakeboardType;
		var specs = [];
		if(skill){
			var percentage = '0%'
			if(skill.includes('advanced')){
				percentage = "80%";
			} else if(skill.includes('intermediate')){
				percentage = "50%";
			} else{
				 percentage = '20%'
			}
			specs.push({
					minValue:'Beginner',
					maxValue:'Intermediate',
					key:'Skill Level',
					percentage:percentage
			})
		}
		if(pop){
			var percentage = '0%';
			if(pop.includes('boosty')){
				percentage = "80%";
			} else if(pop.includes('mid')){
				percentage = "50%";
			} else{
				 percentage = '20%'
			}
			specs.push({
				minValue:'Consistent',
				maxValue:'Boosty',
				key:'Pop',
				percentage:percentage
			})
		}
		if(flex){
			var percentage = '0%';
			if(flex.includes('flexy')){
				percentage = "80%";
			}else{
				 percentage = '20%'
			}
			specs.push({
				minValue:'Mid Flex',
				maxValue:'Flexy',
				key:'Board Flex',
				percentage:percentage
			})
		}
		if(terrain){
			var percentage = '0%';
			if(terrain.includes('boat')){
				percentage = "80%";
			}else{
				 percentage = '20%'
			}
			specs.push({
				minValue:'Cable',
				maxValue:'Boat',
				key:'Terrain',
				percentage:percentage
			})
		}
		this.setState({
			specs:specs
		})
	}

  public render(): JSX.Element {
		if(!this.state.specs) return <span />;
    let customColor:any = null;
    if(this.props.product){
      if(this.props.product.attributes.customSpecsColor){
        if(!this.props.forceBrandColor){
          customColor = this.props.product.attributes.customSpecsColor;
        }
      }
    }
		return (
			<div className="small-max-width-container" style={{paddingBottom:'20px'}}>
        <WakeboardFlexNumber product={this.props.product} />
				<div className="full-width tiny-padding">
					{this.state.specs.map((item:any)=>{
						return(
							<div className="product-spec-row">
								<h4 className="product-spec-key">{item.key}</h4>
								<div className="animated-bar-background full-width global-radius">
									<div className="animated-bar primary-color-background global-radius" style={{'height':'15px','width':item.percentage, backgroundColor:customColor?customColor:'innone'}}>
										&nbsp;
									</div>
								</div>
								<div className="row">
									<div className="small-6 medium-6 left-text subheading product-spec-label">
										<p>{item.minValue}</p>
									</div>
									<div className="small-6 medium-6 right-text subheading product-spec-label" style={{textAlign:'right'}}>
										<p style={{textAlign:'right', width:'100%'}}>{item.maxValue}</p>
									</div>
								</div>
							</div>
						)
					})}
				</div>
			</div>
		)
  }
}

export default WakeboardSpecs;
